var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0066 20.5C16.701 20.5 20.5066 16.6944 20.5066 12C20.5066 7.30558 16.701 3.5 12.0066 3.5C7.31217 3.5 3.50659 7.30558 3.50659 12C3.50659 16.6944 7.31217 20.5 12.0066 20.5ZM12.0066 22C17.5294 22 22.0066 17.5228 22.0066 12C22.0066 6.47715 17.5294 2 12.0066 2C6.48374 2 2.00659 6.47715 2.00659 12C2.00659 17.5228 6.48374 22 12.0066 22Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0066 15.5C13.9396 15.5 15.5066 13.933 15.5066 12C15.5066 10.067 13.9396 8.5 12.0066 8.5C10.0736 8.5 8.50659 10.067 8.50659 12C8.50659 13.933 10.0736 15.5 12.0066 15.5ZM12.0066 17C14.768 17 17.0066 14.7614 17.0066 12C17.0066 9.23858 14.768 7 12.0066 7C9.24517 7 7.00659 9.23858 7.00659 12C7.00659 14.7614 9.24517 17 12.0066 17Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14208 10.9639L4.00659 6.82843L6.83502 4L10.9705 8.13549C9.59407 8.50358 8.51017 9.58748 8.14208 10.9639ZM12.971 8.11704C14.3577 8.46031 15.459 9.5269 15.8515 10.8934L19.9165 6.82843L17.0881 4L12.971 8.11704ZM15.8711 13.0361C15.503 14.4125 14.4191 15.4964 13.0427 15.8645L17.0881 19.9099L19.9165 17.0815L15.8711 13.0361ZM10.9 15.845L6.83502 19.9099L4.00659 17.0815L8.12363 12.9644C8.4669 14.3511 9.53349 15.4524 10.9 15.845Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.b50e2c43157d5ddd2d74ed9e581813a1.svg";
export { ForwardRef as ReactComponent };